"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HitAlwaysAllowedComponent = void 0;
/**
 * @public
 * A {@link IHitAllowedComponent} that always returns true.
 */
class HitAlwaysAllowedComponent {
    isHitAllowed() {
        return true;
    }
}
exports.HitAlwaysAllowedComponent = HitAlwaysAllowedComponent;
//# sourceMappingURL=hit-always-allowed-component.js.map